// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FRPlgHOp{display:flex;flex-direction:column;gap:max(2rem,min(2.08vw,2.5rem));padding-top:max(1rem,min(1.25vw,1.5rem))}.YHdNl6EK{display:grid;grid-template-columns:repeat(auto-fill,minmax(21.88rem,1fr));grid-gap:1rem;gap:1rem}.UC5TwVL2{padding-bottom:max(0rem,min(1.67vw,2rem))}.UC5TwVL2>*+*{margin-top:max(2rem,min(2.08vw,2.5rem))}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xs": "667.98",
	"sm": "947.98",
	"md": "1023.98",
	"lg": "1229.98",
	"container": "FRPlgHOp",
	"events": "YHdNl6EK",
	"eventsWrapper": "UC5TwVL2"
};
module.exports = ___CSS_LOADER_EXPORT___;
